/*
 * Copyright 2026 Sony Corporation
 */
import { SvgIcon, type SvgIconProps } from '@mui/material';

/** A lightning bolt in a lens ring: the app that is built just in time. */
export const AppIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm1.2 2.5-4.7 6.3h3.3l-1 4.7 4.7-6.3h-3.3l1-4.7Z" />
  </SvgIcon>
);

export const ChevronIcon = ({
  direction,
  ...props
}: SvgIconProps & { direction: 'left' | 'right' | 'up' | 'down' }) => (
  <SvgIcon {...props}>
    <path
      d="M15.4 7.4 14 6l-6 6 6 6 1.4-1.4L10.8 12l4.6-4.6Z"
      transform={`rotate(${{ left: 0, up: 90, right: 180, down: 270 }[direction]} 12 12)`}
    />
  </SvgIcon>
);

/** A ring with a filled centre, the common marker of a fact in a list. */
export const DotIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14Zm0 3.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z" />
  </SvgIcon>
);

/** A paper plane: send the message. */
export const SendIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M2.5 21 23 12 2.5 3v7l14 2-14 2v7Z" />
  </SvgIcon>
);

/** A folder: the projects. */
export const ProjectsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M10 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-8l-2-2Z" />
  </SvgIcon>
);

/** A camera: the paired devices. */
export const DevicesIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M9 3 7.2 5H4a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-3.2L15 3H9Zm3 5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9Zm0 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z" />
  </SvgIcon>
);

/** A package box: one built version of the app. */
export const PackageIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M12 2 3 6.5v11L12 22l9-4.5v-11L12 2Zm0 2.2 6.3 3.2L12 10.5 5.7 7.4 12 4.2ZM5 9l6 3v7.3l-6-3V9Zm14 0v7.3l-6 3V12l6-3Z" />
  </SvgIcon>
);

/** A chip: the agent process on the PC. */
export const AgentIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M9 2h2v3h2V2h2v3h1a2 2 0 0 1 2 2v1h3v2h-3v2h3v2h-3v2h3v2h-3v1a2 2 0 0 1-2 2h-1v3h-2v-3h-2v3H9v-3H8a2 2 0 0 1-2-2v-1H3v-2h3v-2H3v-2h3V9H3V7h3V7a2 2 0 0 1 2-2h1V2Zm-1 5v10h8V7H8Zm2 2h4v6h-4V9Z" />
  </SvgIcon>
);

/** Three bars rising: the numbers of the generator. */
export const DashboardIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M4 20V10h3.5v10H4Zm6.25 0V4h3.5v16h-3.5Zm6.25 0v-7H20v7h-3.5Z" />
  </SvgIcon>
);

/** Three dots in a row: more actions. */
export const MoreIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M6 10a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm6 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z" />
  </SvgIcon>
);
